var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"designtool"},[_c('el-container',{staticStyle:{"height":"100%"},attrs:{"direction":"vertical"}},[_c('el-header',[_c('the-hander')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"30%"}},[_c('the-aside')],1),_vm._v(" "),_c('el-main',[_c('the-main')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00c0484d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Product.vue
// module id = null
// module chunks = 